import React from 'react';
import {ProductType} from "../../../../types/product";
import OrderListTable from "../../../components/OrderListTable";

export const ProductsOrderPage = () => {
    return (
        <OrderListTable type={ProductType.GENERAL}/>
    )
}
